import { IVRKeyPresses } from '../../ivr/ivr-key-presses';

export const getKeyPressLength = (keyPress: string) => {
  if (keyPress === IVRKeyPresses.anyKey) {
    return 1;
  }
  return keyPress.trim().length;
};
